import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import TickerBar from '@/pages/home/components/TickerBar';
import LatestFeed from '@/pages/home/components/LatestFeed';
import ExclusiveSection from '@/pages/home/components/ExclusiveSection';
import StarSection from '@/pages/home/components/StarSection';
import InfluencerSection from '@/pages/home/components/InfluencerSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import RankingSection from '@/pages/home/components/RankingSection';
import GuideSection from '@/pages/home/components/GuideSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TickerBar />
        <LatestFeed />
        <ExclusiveSection />
        <StarSection />
        <InfluencerSection />
        <TimelineSection />
        <RankingSection />
        <GuideSection />
      </main>
      <Footer />
    </div>
  );
}